import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AGREEMENT_SECTIONS } from './agreement-sections';

/**
 * Gate shown once per session to a restaurant_admin whose restaurant is
 * `published` but not yet fully `activated`. Deliberately has no close (x) —
 * the user must explicitly Agree (to continue into the dashboard) or Cancel
 * (which signs them out), never dismiss it without choosing.
 */
@Component({
  selector: 'app-published-agreement-modal',
  standalone: true,
  templateUrl: './published-agreement-modal.component.html',
  styleUrl: './published-agreement-modal.component.css',
})
export class PublishedAgreementModalComponent {
  @Input() loading = false;
  @Output() agree = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  readonly agreementSections = AGREEMENT_SECTIONS;

  /** Gates the "I Agree" button — the agreement text itself says acceptance is
   * "checking the box and clicking 'I Agree,'" so the button alone isn't enough. */
  hasAcceptedTerms = false;
}
